import { render, staticRenderFns } from "./HeroLayout.vue?vue&type=template&id=4ff9f20e&scoped=true"
import script from "./HeroLayout.vue?vue&type=script&lang=js"
export * from "./HeroLayout.vue?vue&type=script&lang=js"
import style0 from "./HeroLayout.vue?vue&type=style&index=0&id=4ff9f20e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff9f20e",
  null
  
)

export default component.exports